import { CodeBlockBranch, CodeBlockBranchValue } from "../../../constants";
import {
  BlueprintAdminEnvironment,
  getCurrentBlueprintAdminEnvironment,
} from "./BlueprintVersionEnvironmentLinks";

export const CODE_BLOCK_BRANCH_PRODUCTION_RUN_DISABLED_TOOLTIP =
  "This branch is not merged into production. To use this branch, run blueprint in develop";

export const isRunBlueprintDisabledForCodeBlockBranch = ({
  codeBlockBranch,
  currentEnvironment = getCurrentBlueprintAdminEnvironment(),
}: {
  codeBlockBranch: CodeBlockBranchValue;
  currentEnvironment?: BlueprintAdminEnvironment;
}): boolean =>
  currentEnvironment === BlueprintAdminEnvironment.Production &&
  codeBlockBranch !== CodeBlockBranch.MAIN;
